import { Injectable } from '@angular/core';
import { SettingsService } from '@barthauer/abc/core';
import { LoginSettingsService, ProfileSettingsService } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { ILegendSettings, LegendSetting, LegendSettings } from '../models/legend-settings.model';

@Injectable()
export class LegendSettingsService extends SettingsService<ILegendSettings, LegendSettings, LegendSetting> {
  constructor(
    abcConfigService: AbcConfigService,
    data: DataService,
    loginSettingsService: LoginSettingsService,
    profileSettingsService: ProfileSettingsService
  ) {
    super(
      abcConfigService,
      data,
      loginSettingsService,
      profileSettingsService,
      'MapLegendSettings',
      LegendSettings,
      LegendSetting
    );
  }
}
